'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = require('../events');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = angular.module('ifeis.stages.service', ['ifeis.events']).service('fStages', function ($http, $q, fEventService) {
  /**
   * Instantiating a new fStages instance.
   */
  this.for = function (feis_id) {
    return new fStages(feis_id);
  };

  this.withStage = function (feis_id, stage) {
    return new fStage(feis_id, stage);
  };

  /**
   * Manages stages for a particular Feis
   */

  var fStages = function () {
    function fStages(feis_id) {
      _classCallCheck(this, fStages);

      this._prefix = IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/stages';
      this._feis_id = feis_id;
    }

    /**
     * Get all stages.
     */


    _createClass(fStages, [{
      key: 'all',
      value: function all() {
        return $http.get(this._prefix);
      }
    }, {
      key: 'one',
      value: function one(id) {
        return $http.get(this._prefix + '/' + id);
      }

      /**
       * Create a new stage
       */

    }, {
      key: 'create',
      value: function create(stage) {
        return $http.post(this._prefix, { name: stage.name, dt: stage.dt }).then(function (res) {
          res.dt = stage.dt; // TODO temporary fix until backed returns dt prop for create()
          return res;
        });
      }

      /**
       * Get all unscheduled events
       */

    }, {
      key: 'unscheduled',
      value: function unscheduled() {
        return $http.get(this._prefix + '/events');
      }
    }, {
      key: 'withStage',
      value: function withStage(id) {
        var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        return new fStage(this._feis_id, _extends({ id: id }, props));
      }
    }]);

    return fStages;
  }();

  /**
   * Manages a single stage
   */


  var fStage = function () {
    function fStage(feis_id, stage) {
      _classCallCheck(this, fStage);

      this._stage = stage;
      this._feis_id = feis_id;
      this._prefix = IFEIS_API_URI + '/api/feiseanna/' + this._feis_id + '/stages/' + this._stage.id;
    }

    _createClass(fStage, [{
      key: 'name',
      value: function name() {
        return this._stage.name;
      }
    }, {
      key: 'events',
      value: function events() {
        return this._stage.events;
      }
    }, {
      key: 'remove',
      value: function remove() {
        return $http.delete(this._prefix);
      }
    }, {
      key: 'update',
      value: function update(stageUpd) {
        var _this = this;

        return $http.put(this._prefix, stageUpd).then(function (stage) {
          _this._stage = stage;
          _this._stage.dt = stageUpd.dt;
          return _this._stage;
        });
      }

      /**
       * Get the schedule as it exists now.
       */

    }, {
      key: 'schedule',
      value: function schedule() {
        var _this2 = this;

        var exclude_details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        return $http.get(this._prefix + '/schedule').then(function (stage) {
          if (exclude_details) {
            return stage.events;
          } else {
            return $q.all(stage.events.map(function (e) {
              return e.placeholder ? $q.resolve(e) : fEventService.for(_this2._feis_id).one(e.id);
            })).then(function (events) {
              return events.map(function (e, idx) {
                e.$$participants = stage.events[idx].participants;
                return e;
              });
            });
          }
        });
      }

      /**
       * Attach an item to this stage.
       */

    }, {
      key: 'attach',
      value: function attach(item, before_id, after_id) {
        var endpoint = this._prefix + '/attach-' + (item.placeholder === 1 ? 'placeholder' : 'event');

        return $http.post(endpoint, {
          before_id: before_id,
          after_id: after_id,
          event_id: item.placholder === 1 ? undefined : item.id
        });
      }

      /**
       * Detach an item from a stage
       */

    }, {
      key: 'detach',
      value: function detach(item) {
        var typ = item.placeholder === 1 ? 'placeholder' : 'event';
        var endpoint = this._prefix + ('/detach-' + typ + '/' + item.id);

        return $http.delete(endpoint);
      }
    }]);

    return fStage;
  }();
});


//////////////////
// WEBPACK FOOTER
// ./stages/service.js
// module id = 606
// module chunks = 0